// src/services/api.js

// Define your API base URL.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://installmentzone.com/api';

// Helper function to construct URLs
const endpoint = (path) => `${API_BASE_URL}${path}`;

export const apiEndpoints = {
  // --- From your DashboardPage and initial requirements ---
  getDevices: () => endpoint('/devices/devices.php'),
  getPayments: () => endpoint('/payments/payments.php'),
  getSales: () => endpoint('/sales/sales.php'),
  getAgents: () => endpoint('/agents/agents.php'),
  getCustomers: () => endpoint('/customers/customers.php'),
  
  // --- From your Sidebar.js ---
  getUsers: () => endpoint('/users/users.php'), // Assuming /users/users.php for listing
  // If you need CRUD for users, you'd add:
  // getUserById: (userId) => endpoint(`/users/user.php?id=${userId}`), // Example, depends on your PHP
  // createUser: () => endpoint('/users/create_user.php'), // Example
  // updateUser: (userId) => endpoint(`/users/update_user.php?id=${userId}`), // Example
  // deleteUser: (userId) => endpoint(`/users/delete_user.php?id=${userId}`), // Example

  getProducts: () => endpoint('/products/products.php'),
  // Similar CRUD for products if needed

  getNotifications: () => endpoint('/notifications/notifications.php'),
  // Similar CRUD for notifications if needed

  getAdminDevices: () => endpoint('/admindevices/admindevices.php'), // Or a more specific name like /admin/devices.php
  // Similar CRUD for admin devices if needed

  // --- Dashboard Specific (if you create a summary endpoint later) ---
  // getDashboardSummary: () => endpoint('/dashboard/summary.php'), // Example

  // --- Authentication (Typical for admin panels, adapt to your PHP scripts) ---
  // login: () => endpoint('/auth/login.php'),
  // logout: () => endpoint('/auth/logout.php'),
  // getCurrentUser: () => endpoint('/auth/me.php'),
};

// Example of how you might use this with an HTTP client like axios:
/*
import axios from 'axios';
import { apiEndpoints } from './api';

// To fetch all devices
axios.get(apiEndpoints.getDevices())
  .then(response => {
    if (response.data && response.data.success) {
      console.log(response.data.data); // Access the array of devices
    } else {
      console.error("Failed to fetch devices:", response.data.message);
    }
  })
  .catch(error => console.error("Network or server error fetching devices:", error));
*/